export default function currencyFormat(num) {
  const [a, b] = Number(num)
    .toString()
    .split('.');
  if (b > 0) {
    return `${a.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}.${b}`;
  }
  return `${a.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}`;
}
